import { Injectable } from '@angular/core';
import { PairingStepFormApi } from '../components/pairing-step-form/pairing-step-form.service';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { InsightsServiceApi } from '../components/insights/insights.service';

@Injectable({
  providedIn: 'root',
})
export class DownloadFileService {

  contentDispositionHeader: any;

  constructor(
    private readonly pairingApiService: PairingStepFormApi,
    private readonly insightsServiceApi: InsightsServiceApi,
    private readonly spinnerService: NgxSpinnerService
  ) { }

  downloadCAIFile(userId: string, isMultiplePL: boolean, regionCode: string) {
    this.spinnerService.show();
    return this.pairingApiService.getCAIFile(userId.toString(), isMultiplePL, regionCode).subscribe(
      (response: HttpResponse<any>) => {
        this.spinnerService.hide();
        this.fileDownloadCommonService(response);
      },
      (err: any) => {
        this.spinnerService.hide();
      }
    );
  }

  downloadMissingCAI(fileName: any) {
    this.pairingApiService.getMissingCAIFile(fileName).subscribe(
      (response: HttpResponse<any>) => {
        this.spinnerService.hide();
        this.fileDownloadCommonService(response);
      },
      (err: any) => {
        this.spinnerService.hide();
      }
    );
  }

  fileDownloadCommonService(response: any) {
    const contentDisposition = response.headers.get('Content-Disposition');
    const filenameMatch = contentDisposition?.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    const filename = filenameMatch?.[1]?.trim() || 'download.xlsx';
    const contentType = response.headers.get('Content-Type') || 'application/vnd.ms-excel';
    const blob = new Blob([response.body], { type: contentType });

    FileSaver.saveAs(blob, filename);
  }

  downloadPriceFXFile() {
    this.spinnerService.show();
    return this.insightsServiceApi.getPriceFXFile().subscribe(
      (response: HttpResponse<any>) => {
        this.spinnerService.hide();
        this.fileDownloadCommonService(response);
      },
      (err: any) => {
        this.spinnerService.hide();
      }
    );
  }

}
